import { getSnowplowEventPayload, logAnalyticsEvent } from '../../analytics';
import { SNOWPLOW_EVENTS } from '../../analytics.const';

import {
	VEHICLE_DETAILS_IMAGE_EVENTS,
	VEHICLE_DETAILS_IMAGE_SECTIONS,
	VEHICLE_DETAILS_IMAGE_ZOOM_LEVELS,
} from './galleryEvents.consts';
import type { ZoomEventsParams } from './galleryEvents.types';

export const triggerZoomOutImageEvent = ({ section, zoomLevel }: ZoomEventsParams): void => {
	const zoomLevelLabel = VEHICLE_DETAILS_IMAGE_ZOOM_LEVELS[`LEVEL_${zoomLevel}`];

	const snowplowEventPayload = getSnowplowEventPayload({
		category: VEHICLE_DETAILS_IMAGE_SECTIONS[section],
		customData: { label: zoomLevelLabel },
		name: VEHICLE_DETAILS_IMAGE_EVENTS.ZOOM_OUT.snowplow,
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload: snowplowEventPayload });
};
